import {createTheme} from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        primary: {
            main: '#00b7f0',
            dark: '#11486e',
            contrastText: '#fff'
        },
        secondary: {
            main: 'rgb(255, 255, 255)',
            dark: 'rgba(0, 0, 0, 0.04)',
            contrastText: '#000'
        },
        error: {
            main: '#750829',
        },
        success: {
            main: '#4fa83f',
        },
        warning: {
            main: '#e48c00',
        },
        default: {
            main: '#11486e',
        },
        lightGray: {
            main: 'rgba(0, 0, 0, 0.05)',
            text: '#999',
        },
        lightBlue: {
            main: '#f2fbfe',
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 1100,
            lg: 1300,
            xl: 1536,
        },
    },
    components: {
        MuiTypography: {
            styleOverrides: {
                body1: {
                    fontSize: '1.6rem'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    paddingTop: 8,
                    paddingBottom: 8,
                    fontSize: '1.6rem',
                    textTransform: 'none',
                    minWidth: '25px !important',
                },
            }
        },
        MuiButtonGroup: {
            styleOverrides: {
                grouped: {
                    '&:not(last-of-type)': {
                        borderRight: 'none !important',
                    }
                }
            }
        },
        MuiStepLabel: {
            styleOverrides: {
                alternativeLabel: {
                    fontSize: '1.6rem',
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                    color: '#333333',
                    boxShadow: "none",
                }
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    fontSize: '1.4rem',
                    borderRadius: '0',
                    '&::after': {
                        border: '0 !important',
                    },
                    '&::before': {
                        border: '0 !important',
                    },
                },
                input: {
                    height: '1rem',
                },
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1.2rem',
                    lineHeight: '1rem',
                    overflow: 'visible',
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                filled: {
                    lineHeight: '1rem',
                },
                select: {
                    height: '1rem',
                    minHeight: '1rem',
                    fontSize: '1.4rem',
                },
            }
        },
        MuiCalendarPicker: {
            styleOverrides: {
                PrivatePickersFadeTransitionGroup: {
                    root: {
                        fontSize: '1.4rem',
                    },
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '1.4rem',
                }
            }
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    fontSize: '1.4rem',
                },
                icon: {
                    fontSize: '2.4rem',
                }
            }
        }
    }
});